module.exports = __webpack_public_path__ + "img/VTC.87d75445.svg";